function isClonable(obj) {
    return (typeof obj === 'object')
        && (obj !== null)
        && ('clone' in obj)
        && typeof obj.clone === 'function';
}
export { isClonable };
//# sourceMappingURL=clonable.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/inversify/es/utils/clonable.js
// module id = 1726
// module chunks = 0